export enum PragmaticEvents {
  GAME_READY = 'gameLoadingEnded',
  ROUND_START = 'gameRoundStarted',
  ROUND_END = 'gameRoundEnded',
  UPDATE_BALANCE = 'refreshBalance',
  AUTO_SPIN_STOP = 'stopAutoplay',
  HOME_REDIRECT = 'gameQuit',
  SHOW_DEPOSIT = 'openCashier',
  SET_VOLUME = 'setVolume',
  SOUND_OFF = 'soundOff',
  SOUND_ON = 'soundOn',
  INSUFFICIENT_FUNDS = 'balanceTooLow',
  SYSTEM_MESSAGE_SHOWN = 'systemMessageShown',
  TOGGLE_HELP = 'toggleHelp',
  TOGGLE_PAYTABLE = 'togglePaytable',
  GAME_CHANGE = 'gameChange',
}

type PragmaticEventFieldType =
  | PragmaticEvents.UPDATE_BALANCE
  | PragmaticEvents.SET_VOLUME
  | PragmaticEvents.SOUND_OFF
  | PragmaticEvents.SOUND_ON
  | PragmaticEvents.SYSTEM_MESSAGE_SHOWN
  | PragmaticEvents.GAME_CHANGE;

export type PragmaticEventData = {
  name?: PragmaticEvents;
  event?: PragmaticEventFieldType;
  params?: {
    muted: boolean;
    ext_code?: string;
    frozen?: string;
    msg_code?: string;
    type?: string;
    gameCode?: string;
  };
};
